import script from "./MySubscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./MySubscription.vue?vue&type=script&setup=true&lang=ts"

import "./MySubscription.vue?vue&type=style&index=0&id=64375738&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64375738"]])

export default __exports__